import { render, staticRenderFns } from "./GivenchyGentleman.vue?vue&type=template&id=3592ed4a&scoped=true&"
import script from "./GivenchyGentleman.vue?vue&type=script&lang=js&"
export * from "./GivenchyGentleman.vue?vue&type=script&lang=js&"
import style0 from "./GivenchyGentleman.vue?vue&type=style&index=0&id=3592ed4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592ed4a",
  null
  
)

export default component.exports